const PLATFORMS = {
    MOBILE: 'mobile_web',
    WEB: 'web'
};

module.exports = {
    PLATFORMS
};
